import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardDividerElement,
} from "@easy-email-pro-core/typings";
import React from "react";

import { Divider } from "@easy-email-pro-core/components/Elements";

import { Divider as SourceElement } from "../../basic/Divider";

const defaultData: ElementDefinition<StandardDividerElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {},
  });

export const StandardDivider = createBlock<StandardDividerElement>({
  get name() {
    return t("Divider");
  },
  defaultData,
  void: true,
  type: StandardType.STANDARD_DIVIDER,
  create: (payload) => {
    const defaultData: StandardDividerElement = {
      type: StandardType.STANDARD_DIVIDER,
      data: {},
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.DIVIDER,
  render(params) {
    const { node } = params;

    return (
      <Divider
        idx={params.idx}
        {...node.attributes}
        data={node.data}
        children={params.children || node.children}
      />
    );
  },
});
